import { translationKey } from "./i18n";

export enum ProcessStep {
	SelectCompany = "selectCompany",
	PreconditionFailed = "preconditionFailed",
	CreditRisk = "creditRisk",
	ContactThanks = "contactThanks",
	Identification = "identification",
	BasketSelection = "basketSelection",
	OrderInformation = "orderInformation",
	Summary = "summary",
	Finished = "finished",
	Error = "error"
}

export interface NavigationItem {
	step: ProcessStep;
	text: translationKey;
}

export const orderNavigationItems: NavigationItem[] = [
	{ step: ProcessStep.BasketSelection, text: "naviBasketSelection" },
	{ step: ProcessStep.OrderInformation, text: "naviOrderInfo" },
	{ step: ProcessStep.Summary, text: "naviSummary" },
	{ step: ProcessStep.Finished, text: "naviFinished" }
];
